module.exports = {
  "country": "NL",
  "artist": "Lenny Kuhr",
  "song": "De Troubadour",
  "year": "1969",
  "place": "1",
  "spotify": "31VRNSB6FA4KP7TOkW3k3A"
};